var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(!_vm.hideSplash)?_c('div',{staticClass:"splash-background"},[_c('div',{staticClass:"splash-image-wrapper"},[_c('transition',{attrs:{"name":"bounce"}},[(_vm.showImage)?_c('v-avatar',{staticClass:"splash-logo",attrs:{"size":"200"}},[_c('v-img',{attrs:{"src":_vm.currentInstitution.logo}})],1):_vm._e()],1)],1)]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }